<template>
  <div>
    <!-- 检索条件 -->
    <div>
      <el-form :inline="true" @submit.native.prevent>
        <el-row>
          <el-form-item label="客户">
            <el-input style="width:200px" placeholder="'请输入客户" v-model.trim="queryMap.smName"
            clearable  size="mini">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="mini" @click="searchData">查询</el-button>
          </el-form-item>
        </el-row>
      </el-form>
    </div>
    <!-- 表格 -->
    <el-table ref="multipleTable" height="360" size="mini" @row-click="handleClick" style="width: 100%" :data="settleDataList" border stripe highlight-current-row :header-cell-style="getHeaderCellStyle">
      <el-table-column v-for="(item,index) in settleList" :key="index"  
      align="center" min-width="140" 
      :prop="item.props" :label="item.label" 
      :show-overflow-tooltip="true">
        <template slot-scope="scope">
            <div v-if="item.props == 'dsapmDate'">
               <span>{{$common.getLocalTime(scope.row[item.props])}}</span>
            </div>
            <div v-else-if="item.props == 'createTime'">
                <span>{{$common.getLocalTime(scope.row[item.props],true)}}</span>
            </div>
            <div v-else-if="item.props == 'settleMode'">
                <el-tag v-if="scope.row.settleMode == 0">{{scope.row.settleMode == 0 ? '按单据' : '按明细'}}</el-tag>
            </div>
            <div v-else-if="item.props == 'dpsmState'">
                <div v-for="(x,y) in stateList" :key="y">
                    <el-tag v-if="x.key == scope.row.dpsmState">{{x.value}}</el-tag>
                </div>
            </div>
            <!-- 库房 -->
            <span v-else>{{settleDataList[scope.$index][item.props]}}</span>
        </template>
      </el-table-column>
      <el-table-column v-if="!isDetail" fixed="right" label="操作" width="110" align="center">
        <template slot-scope="scope">
          <el-button size="mini" type="text" @click.stop="handleSelectClick(scope.row)">确认选择</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="pageSizes" background :page-size="pageSize"
      layout="total, sizes, prev, pager, next" :total="total">
    </el-pagination>
        <div style="margin: 10px 0;">
          <el-tag v-if="tableType == 0">单据表格</el-tag>
          <el-tag v-if="tableType == 1">明细表格</el-tag>
        </div>
        <!-- 明细表(按单据) -->
        <el-table v-if="tableType == 0" size="mini" height="200" :data="detailDataBill" border stripe highlight-current-row :header-cell-style="getHeaderCellStyleD" style="width: 100%">
          <el-table-column v-for="(item,index) in settleBills" :key="index"  
            align="center" min-width="140" 
            :prop="item.props" :label="item.label" 
            :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    <div v-if="item.props == 'dpsmDate'">
                        <div>
                            {{ $common.getLocalTime(scope.row[item.props]) }}
                        </div>
                    </div>
                    <div v-else-if="item.props == 'createTime'">
                        <div>
                            {{$common.getLocalTime(scope.row[item.props])}}
                        </div>
                    </div>
                    <span v-else>{{detailDataBill[scope.$index][item.props]}}</span>
                </template>
            </el-table-column>
        </el-table>
        <!-- 明细表(按明细) -->
        <el-table v-if="tableType == 1" size="mini" height="280" :data="detailDataMx" border stripe highlight-current-row :header-cell-style="getHeaderCellStyleD" style="width: 100%">
          <el-table-column v-for="(item,index) in settleDetails" :key="index"  
            align="center" min-width="140" 
            :prop="item.props" :label="item.label" 
            :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    <div v-if="item.props == 'dpsmDate'">
                        <div>
                            {{ $common.getLocalTime(scope.row[item.props]) }}
                        </div>
                    </div>
                    <div v-else-if="item.props == 'createTime'">
                        <div>
                            {{$common.getLocalTime(scope.row[item.props])}}
                        </div>
                    </div>
                    <span v-else>{{detailDataMx[scope.$index][item.props]}}</span>
                </template>
            </el-table-column>
        </el-table>
      <!-- </el-collapse-item>
    </el-collapse> -->
  </div>
</template>
<script>
export default {
  name: "ExtractionSchemeSalesSettle",
  components: {},
  data() {
    return {
        opmId: "",
        ormId: "",
        detailsub: true,
        activeName: "1",
        showdetail: false,
        detailData: [],
        currentPage: 1,
        pageSizes: [10, 25,30, 50, 100],
        pageSize: 10,
        total: 0,
        tableData: [],
        isPagination: "",
        queryMap: {
            page: 1,
            rows: 30,
            smName: ''
        },
        detailDataMx: [],
        detailDataBill: [],
        tableType: 0,
        searchTermList: [], //检索条件
        Columns: [],
        ColumnsDetail: [],
        isDetail: false,
        multipleSelection: [], //数组内层
        objList: [], //外层数组
        stateList: [
            {"key":0,"value":"初始"},
            {"key":1,"value":"提交"},
            {"key":2,"value":"已记账"}
        ],
        settleList: [
            {
                props: 'dsapmId',
                label: '销售结算申请单号'
            },
            {
                props: 'dsapmDate',
                label: '申请日期'
            },
            {
                props: 'cmName',
                label: '客户'
            },
            {
                props: 'coName',
                label: '货主'
            },
            {
                props: 'opmName',
                label: '业务员'
            },
            {
                props: 'salesName',
                label: '对方业务员'
            },
            {
                props: 'depName',
                label: '业务部门'
            },
            {
                props: 'createTime',
                label: '创建时间'
            },
            {
                props: 'dpsmRemark',
                label: '备注'
            },
            {
                props: 'settleMode',
                label: '结算方式'
            },
            {
                props: 'payMethod',
                label: '支付方式'
            },
            {
                props: 'sbiAddress',
                label: '银行地址'
            },
            {
                props: 'sbiNumber',
                label: '银行账号'
            },
            {
                props: 'sbiName',
                label: '公司银行'
            },
            {
                props: 'dsapmState',
                label: '状态'
            }
        ],
        settleDataList: [],
        settleBills: [
            {
                props: 'rowno',
                label: '行号'
            },
            {
                props: 'dsapdId',
                label: '结算申请单号'
            },
            {
                props: 'businessId',
                label: '业务单号'
            },
            {
                props: 'businessType',
                label: '业务类型'
            },
            {
                props: 'totalMoney',
                label: '总金额'
            },
            {
                props: 'settlementMoney',
                label: '已结算金额'
            },
            {
                props: 'oldBalance',
                label: '上期余额'
            },
            {
                props: 'settleMoney',
                label: '付款金额'
            }
        ],
        settleDetails: [
            {
                props: 'rowno',
                label: '行号'
            },
            {
                props: 'dsapdId',
                label: '结算申请单号'
            },
            {
                props: 'bgmName',
                label: '通用名称'
            },
            {
                props: 'spec',
                label: '规格'
            },
            {
                props: 'bgpUnitmeasurement',
                label: '包装单位'
            },
            {
                props: 'packingSpec',
                label: '装箱规格'
            },
            {
                props: 'manufacturer',
                label: '生产厂商'
            },
            {
                props: 'placeorigin',
                label: '产地'
            },
            {
                props: 'psprice',
                label: '含税价格'
            },
            {
                props: 'psmoney',
                label: '含税金额'
            },
            {
                props: 'settlementMoney',
                label: '已结算金额'
            },
            {
                props: 'oldBalance',
                label: '上期余额'
            },
            {
                props: 'settleMoney',
                label: '付款金额'
            }
        ]
    };
  },
  watch: {},
  computed: {},
  mounted() {},
  created() {
      this.getSettleList()
      this.$emit("getWidth", '95');
      this.$emit("sendTitle", '提取销售结算申请单');
  },
  methods: {
    async getSettleList() {
        var responseData =  await this.$http.getSalesSettlementKeepExtract(this.queryMap)
        if(responseData.status == 200){
            this.settleDataList = responseData.result.list
            this.total = this.settleDataList.length;
            if (this.settleDataList[0].settleMode == 0) {
                this.tableType = 0
                this.detailDataBill = this.settleDataList[0].suSettleInvoiceVos
            } else if (this.settleDataList[0].settleMode == 1) {
                this.tableType = 1
                this.detailDataMx = this.settleDataList[0].suSettleInvoiceDetailVos
            }
        }else{
            this.$message({
                message: responseData.message,
                type: 'error'
            });
        }
        this.$refs.multipleTable.doLayout();
    },
    // 双击主表格确认
    async handleSelectClick(row) {
      // 是否可选择明细
      if (this.isDetail) {
        return this.$message.error("请选择明细");
      }
      if (this.tableData && this.tableData.length) {
        let queryMap = {
          id: row[this.ppId],
          extractId: this.id,
        };
        await this.getTableDetailList(queryMap);
      }
      row.arrlistbychen = this.detailData;
      this.$emit("TranData", row);
    },
    // 勾选明细
    handleSelectionChange(val) {
      this.multipleSelection = val;
      if (val.length) {
        this.detailsub = false;
      } else {
        this.detailsub = true;
      }
    },
    sureDetail() {
      this.objList.arrlistbychen = this.multipleSelection;
      this.$emit("TranData", this.objList);
    },
    // 单击表格
    handleClick(row) {
    //   this.objList = row;
      if (row.settleMode == 0) {
          this.tableType = 0
          this.detailDataBill = row.suSettleInvoiceVos
      } else if (row.settleMode == 1) {
          this.tableType = 1
          this.detailDataMx = row.suSettleInvoiceDetailVos
      }
    },
    // 检索条件赋值
    handleChange(value, name) {
      // value默认参，name当前所需的name
      this.queryMap[name] = value;
    },
    //   查询
    searchData() {
      this.currentPage = 1;
      this.queryMap.page = 1;
      this.getSettleList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.queryMap.rows = val;
      this.getSettleList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.queryMap.page = val;
      this.getSettleList();
    },
    //   -----------------------------------------------------
    getHeaderCellStyle() {
      return "background: skybule; borderBottom: solid 1px #5a5e66;color: #3e5569";
    },
    getHeaderCellStyleD() {
      return "background: skybule;color: #3e5569";
    },
  },
};
</script>
<style scoped>
.el-pagination {
  padding: 20px 0px 5px;
}
</style>
